import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Img1 from "../Assets/Home/IITMIC logo.png";
import Img2 from "../Assets/Home/hyperverge-logo.webp";
import Img4 from "../Assets/Home/logo-cogniphy.png";
import Img5 from "../Assets/Home/side3.jpg";
import Img6 from "../Assets/Home/side1.jpg";
import Img7 from "../Assets/Home/Kalaari-Logo.png"
import Img8 from "../Assets/Paststudent.png";
import Img9 from "../Assets/Home/side2.jpg";
import Img11 from "../Assets/nexus.png";
import Img12 from "../Assets/Home/nithin.png";
import Img13 from "../Assets/Home/Eashwar.png";
import Img14 from "../Assets/Home/Krishaka.png";
import Img15 from "../Assets/Home/6.jpeg";
import Img16 from "../Assets/Home/logo.png";
import Img17 from "../Assets/Home/side4.jpeg";
import Img18 from "../Assets/Home/side5.jpg";
import Img19 from "../Assets/Home/american_express_logo.svg";
import Img20 from "../Assets/Home/Java Capital.avif";
import Img21 from "../Assets/Home/algram.png";
import Img22 from "../Assets/Home/NATESAN.jpg";
import Img23 from "../Assets/Home/aptiv.png";
import Img24 from "../Assets/Home/murugaiyan.png";
import img25 from "../Assets/Delta_Expo_Invite.jpg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import CountUp from "react-countup";
import { CiLocationOn, CiMail, CiYoutube } from "react-icons/ci";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import Footer from "../Components/Footer";
import Marquee from "react-fast-marquee";
import WhatWeOffer from "../Components/Eligibility";
import ApplicationProcess from "../Components/ApplicationProcess";
import { FaBullhorn, FaHandPointRight, FaTimes } from "react-icons/fa";
const stats = [
  { id: 1, label: "Active Teams", value: 242 },
  { id: 2, label: "Revenue Generated By Startups", value: 80 },
  { id: 3, label: "Sectors In Focus", value: 10 },
  { id: 4, label: "Total Valuation", value: 1000 },
  { id: 5, label: "Startup incubated at IITMIC", value: 19 },
  { id: 6, label: "Total Number of Teams Trained", value: 319 },
  { id: 7, label: "Startup Registered in MCA", value: 76 },
  { id: 8, label: "IPs filed", value: 62 },
];
const announcements = [
  {
    text: "Call for Applications for Nirmaan Feb'26 Cohort",
    link: "https://traktor.sieiitm.org",
  },
];


const Carousel = () => {
  const slides = [
    {
      Img: Img8,
      img: Img16,
      name: "Akash Anand",
      title: "Founder, Clueso",
      content: (
        <>
          <p>
            Nirmaan has been an invaluable partner in our journey from concept
            to a thriving startup. Their comprehensive support, including
            technical assistance, financial aid, and access to a network of
            experienced mentors, has been instrumental in our success. The
            workshops provided us with essential skills, and the
            state-of-the-art infrastructure offered an ideal environment for
            innovation and growth. Nirmaan's dedication to nurturing young
            entrepreneurs is truly commendable, and we are grateful for their
            unwavering support. Thanks to Nirmaan, Clueso has transformed from a
            mere idea into a successful business.
          </p>
        </>
      ),
    },
    {
      Img: Img12,
      img: Img11,
      name: "Nithin Maloth",
      title: "Founder, Nexuscare",
      content: (
        <>
          <p>
            From the very beginning, I've been with Nirmaan and have seen it
            evolve into a model of excellence. Medlock (now registered as
            Nexuscare) has benefitted immensely from the steadfast support of
            the Nirmaan team, particularly under the guidance of manager Nandini
            Ma’am. I recommend Nirmaan as the perfect starting point for any
            entrepreneur. The founder’s journey is typically solitary and
            perplexing, but with Nirmaan, it has been a collaborative and clear
            path.
          </p>
        </>
      ),
    },
    {
      Img: Img13,
      img: Img14,
      name: "Easwar Veeragandham",
      title: "Founder, Krishaka",
      content: (
        <>
          <p>
            "Krishaka has been part of the Nirmaan Preincubation Cell at IIT
            Madras for the past two years. Nirmaan provided us with invaluable
            mentorship, field contacts, manufacturing support, and prototyping
            funding. Their organized talks with industry veterans enriched our
            knowledge and guided our growth. Thanks to their unwavering
            commitment to innovation, Krishaka could turn ideas into a feasible
            business. Special thanks to Nandhini mam for her constant support
            throughout our journey."
          </p>
        </>
      ),
    },

    // Additional slides can be added here.
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div
      className=" text-white p-4 mt-8 px-8"
      style={{ backgroundColor: "#abf7af" }}
    >
      <div className="relative w-full max-w-7xl mx-auto mt-6 ">
        <div className="md:grid md:grid-cols-5">
          {/* Left Column: Slide Content */}
          <div
            className="col-span-3 overflow-hidden rounded-lg shadow-lg  "
            style={{ backgroundColor: "#4c9c50" }}
          >
            <div
              className="flex transition-transform duration-500"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {slides.map((slide, index) => (
                <div key={index} className="w-full flex-shrink-0 p-6">
                  <div className="flex items-center mb-4 font-dmsans">
                    <div className="mr-2 mt-1">
                      <img
                        src={slide.Img}
                        className="h-16 rounded-full"
                        alt={slide.name}
                      />
                    </div>

                    <div className="mr-2 mt-1">
                      <img src={slide.img} className="h-7 font-dmsans" alt={slide.name} />
                    </div>
                    <div>
                      <span className="font-semibold font-dmsans">{slide.name}</span>
                      <div className="text-md font-dmsans">{slide.title}</div>
                    </div>
                  </div>
                  <div className="text-sm mt-2 text-justify font-dmsans">
                    {slide.content}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Arrows and Dots */}
          <div className="col-span-2 ">
            <div className="text-left  ">
              <h1 className="text-[25px] font-semibold font-dmsans mt-6 ml-16 text-black">
                Inspiring <span className="text-green-600">testimonials</span> from
                the members of the past
              </h1>
            </div>
            <div className="flex items-center space-x-4 ml-16 mt-4">
              <button onClick={prevSlide} className="flex items-center">
                <div className="border rounded-lg p-2 bg-green-600">
                  <FaChevronLeft />
                </div>
              </button>
              <button onClick={nextSlide} className="flex items-center">
                <div className="border rounded-lg p-2 bg-green-600">
                  <FaChevronRight />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4 space-x-2 mr-8">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full ${
              currentIndex === index ? "bg-green-600" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

const StatCounter = ({ stat }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger the count-up once
    threshold: 0.1, // Trigger when 10% of the element is in view
  });

  return (
    <div className="p-6 rounded-lg shadow-lg text-center">
      <div className="text-3xl font-semibold text-white font-dmsans">
        <div
          className="rounded-lg p-2"
          ref={ref}
          style={{ backgroundColor: "#4c9c50" }}
        >
          {inView && (
            <CountUp
              end={stat.value}
              suffix={
                stat.label === "Total Valuation" ||
                stat.label === "Revenue Generated By Startups"
                  ? " Cr+"
                  : stat.label === "Sectors In Focus" ||
                    stat.label === "Women Entrepreneurs"
                  ? "+"
                  : ""
              }
              duration={2} // Duration of the count-up animation in seconds
            />
          )}
        </div>
      </div>

      <div className="mt-4 text-sm text-gray-900 font-dmsans">{stat.label}</div>

      {/* Conditionally render the 2023-2024 cohorts information below "Active Teams" */}
      {stat.label === "Active Teams" && (
        <div className="mt-1 text-xs italic text-gray-900 font-dmsans">
          (till sept-2025 Cohort)
        </div>
      )}
      {stat.label === "Total Number of Teams Trained" && (
        <div className="mt-1 text-xs italic text-gray-900 font-dmsans">
          (till Sept-2025 Cohort)
        </div>
      )}
    </div>
  );
};

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-white">
      <Navbar />
      {/* <div
        className="relative overflow-hidden whitespace-nowrap  mt-32"
        style={{ backgroundColor: "#4c9c50" }}
      >
        <div className="flex animate-marquee font-dmsans  text-white">
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
          <span className="mx-6"> DEMO DAY: 27 September 2024</span>
        </div> for below the navbar - mt-[80px]
      </div> */}
      {/* image popup shown on every visit after delay */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg max-w-md mx-4 relative">
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-2 text-red-500 hover:text-gray-700"
            >
              <FaTimes />
            </button>
            <img
              src={img25}
              alt="Popup Image"
              className="w-full h-auto rounded"
            />
          </div>
        </div>
      )}

      <div className="w-full bg-[#f8f9fa] py-2 flex items-center overflow-hidden border-b border-gray-200 mt-24">
  <div className="bg-white text-red-500 font-semibold flex items-center px-4 py-2 rounded-md ml-4 z-10 shrink-0 text-lg">
    <FaBullhorn className="mr-2" />
    Announcements
  </div>

  <div className="relative w-full overflow-hidden">
    <div className="flex animate-marquee text-[#002855] text-lg font-semibold whitespace-nowrap">
      {announcements.map((item, idx) => (
        <span key={idx} className="mx-8 text-poppins">
          <FaHandPointRight className="inline text-green-600 mr-1" />
          {item.text} —{" "}
          <a
            href={item.link}
            className="font-semibold underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Application Closed
          </a>
        </span>
      ))}

      {/* Duplicate once for smooth infinite scroll */}
      {announcements.map((item, idx) => (
        <span key={`dup-${idx}`} className="mx-8 text-poppins">
          <FaHandPointRight className="inline text-green-600 mr-1" />
          {item.text} —{" "}
          <a
            href={item.link}
            className="font-semibold underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Application closed
          </a>
        </span>
        
      ))}
      {announcements.map((item, idx) => (
        <span key={`dup-${idx}`} className="mx-8 text-poppins">
          <FaHandPointRight className="inline text-green-600 mr-1" />
          {item.text} —{" "}
          <a
            href={item.link}
            className="font-semibold underline"
            target="_blank"
            rel="noopener noreferrer"
          >
             Application closed
          </a>
        </span>
        
      ))}
      {announcements.map((item, idx) => (
        <span key={`dup-${idx}`} className="mx-8 text-poppins">
          <FaHandPointRight className="inline text-green-600 mr-1" />
          {item.text} —{" "}
          <a
            href={item.link}
            className="font-semibold underline"
            target="_blank"
            rel="noopener noreferrer"
          >
             Application closed
          </a>
        </span>
        
      ))}
    </div>
  </div>
</div>

      <div className="mt-[40px]   md:grid md:grid-cols-2 gap-3 ">
        <div>
          <div className=" max-w-xl mx-auto bg-white rounded-xl space-y-4 bg-gray-50 mt-16 content-left">
            <div className="text-center">
              <h1 className=" font-bold font-dmsans">
                <span className="text-green-600 text-6xl mt-10">NIRMAAN</span>{" "}
                <br />
                <div className="text-xl">THE PRE - INCUBATOR, IIT MADRAS</div>
              </h1>
              <p className="mt-8 text-gray-900 font-dmsans text-justify p-2">
                Nirmaan at IIT Madras is the first of its kind dedicated
                pre-incubator on a college campus in the country. Nirmaan is
                committed to advancing innovation and entrepreneurship by
                providing comprehensive technical guidance and business
                mentorship to students. Our support focuses on enhancing the
                robustness of their business ideas and ensuring their economic
                feasibility. Through mentorship and strategic insights, we help
                students transform their ideas into successful, ventures.
              </p>
            </div>
          </div>
        </div>
        <div className="space-y-4 mt-8">
          
          {/* TOP ROW – 2 IMAGES */}
          <div className="grid grid-cols-2 gap-4">
            <img
              src={Img5}
              alt="Image 1"
              className="w-full h-[200px] object-cover rounded-lg"
            />
            <img
              src={Img6}
              alt="Image 2"
              className="w-full h-[200px] object-cover object-top rounded-lg "
            />
          </div>

          {/* BOTTOM ROW – 3 IMAGES */}
          <div className="grid grid-cols-3 gap-4">
            <img
              src={Img9}
              alt="Image 3"
              className="w-full h-[150px] object-cover rounded-lg"
            />
            <img
              src={Img17}
              alt="Image 4"
              className="w-full h-[150px] object-cover object-top rounded-lg"
            />
            <img
              src={Img18}
              alt="Image 5"
              className="w-full h-[150px] object-cover rounded-lg"
            />
          </div>

        </div>
        {/* <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-2 md:px-6">
          
          <div className="hidden md:block md:col-span-1" />

        
          <motion.div
            className="col-span-12 md:col-span-5 mt-8 md:mt-16 bg-gray-50 rounded-xl mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.img
              src={Img6}
              className="w-full sm:w-[400px] md:w-[300px] h-auto sm:h-[250px] md:h-[150px] rounded-lg mx-auto"
              alt="Image 1"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            />
          </motion.div>

        
          <motion.div
            className="col-span-12 md:col-span-5 mt-8 md:mt-16 bg-gray-50 rounded-xl mx-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.img
              src={Img15}
              className="w-full sm:w-[500px] md:w-[300px] h-auto sm:h-[300px] md:h-[150px] rounded-lg mx-auto"
              alt="Image 9"
            />
          </motion.div>

          
          <div className="hidden md:block md:col-span-1" />

          
          {[Img17, Img18, Img5].map((img, index) => (
            <motion.div
              key={index}
              className="col-span-12 sm:col-span-4 md:col-span-4 mt-4 bg-gray-50 rounded-xl p-1 mx-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <motion.img
                src={img}
                className="w-full h-auto md:h-[138px] rounded-lg"
                alt={`Image ${index + 1}`}
              />
            </motion.div>
          ))}
        </div> */}
      </div>

      <div className="p-6 max-w-xl mx-auto bg-white rounded-xl space-y-4 bg-gray-50 mt-8 content-bottom">
        <div className="text-center">
          <h1 className="text-4xl font-bold font-dmsans text-green-600">
            Nirmaan in Numbers
          </h1>
        </div>
      </div>
      <div className="p-4">
        <div className="flex justify-center items-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-cols-4 gap-4 content-bottom">
            {stats.map((stat) => (
              <StatCounter key={stat.id} stat={stat} />
            ))}
          </div>
        </div>
        {/* Pre incubaton starts here */}
        <div className="">
                        <div className="p-5 flex"></div>
                        <h2 className="md:text-4xl font-bold text-green-600 pt-8 pb-3 text-center font-dmsans sm:text-3xl">Pre-Incubation Program</h2>
                        
                </div> 
        <p className="mr-16 ml-16 font-dmsans mt-6 ">
          {" "}
          Nirmaan offers two exciting programs for student teams ready to embark
          on their entrepreneurial journey: Pratham and Akshar. Pratham gives
          you the core skills and knowledge to build a successful startup from
          the ground up. Akshar, on the other hand, focuses on helping you
          create a Minimum Viable Product (MVP) to test and refine your business
          idea. With Pratham’s foundational training and Akshar’s MVP
          development support, you’ll have everything you need to turn your
          entrepreneurial vision into reality
        </p>{" "}
     
      {/* What We Offer Section */}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-24 px-10">
        <div className="text-center border mt-4 rounded-lg p-6 border border-green-500">
          <h3 className="text-2xl font-semibold mb-4 text-green-600 font-dmsans">
            Pratham - 6 Month Program
          </h3>
          <p className="text-gray-900 mb-6 leading-relaxed text-justify font-dmsans">
            Jumpstart your entrepreneurial journey with our 6-Month
            Program, Pratham, named after the Sanskrit word for "first.” This
            intensive program will guide student teams through the basics of
            business, finance, and market strategy, helping them turn their
            ideas into real possibilities. Here, each selected team will be
            equipped with a seed grant of ₹2 Lakhs, empowering them to conduct
            in-depth market research and develop prototypes.
          </p>
        </div>

        {/* Akshar Card */}
        <div className="text-center border mt-4 rounded-lg p-6 border border-green-500">
          <h3 className="text-2xl font-semibold mb-4 text-green-600 font-dmsans">
            Akshar - 6 Month MVP Development
          </h3>
          <p className="text-gray-900 mb-6 leading-relaxed text-justify font-dmsans">
            Teams that shine in the Pratham phase will advance to the Akshar
            phase—a 6-month program designed to elevate your project. Here,
            you'll focus on developing your Minimum Viable Product (MVP) and
            mastering advanced business strategies like pricing, sales, and
            marketing. Each team will be granted ₹5 Lakhs to support MVP
            creation, in-depth market research, and connections with industry
            professionals. This is your opportunity to refine your project and
            make a lasting impact!
          </p>
        </div>
      </div>
      <section className=" bg-white  p-8 mt-[50px]">
        <h2 className="text-center text-3xl font-bold font-dmsans  text-green-600 mb-8">
          What We Offer
        </h2>
        <WhatWeOffer />
      </section>
      {/* <section className="mb-16 bg-gradient-to-r from-green-100 via-white to-green-200 shadow-md rounded-lg p-8">
        <h2 className="text-center text-3xl font-bold font-dmsans text-green-600 mb-8">
          Application Process
        </h2>
        <ApplicationProcess />
        </section> */}
        <div className="font-semibold text-2xl sm:text-3xl text-green-600 font-dmsans flex justify-center items-center mt-8 sm:mt-16 text-center sm:text-left">
          Message from the Faculty Advisor
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-7 px-4 sm:px-10 mt-8 sm:mt-10 gap-6 sm:gap-14">
          <div className="col-span-1 sm:col-span-2 flex justify-center items-center">
            <img
  src={Img24}
  className="h-[240px] sm:h-[270px] w-full sm:w-[400px] object-cover object-[50%_30%] sm:object-center"
  alt="Faculty Advisor"
/>


          </div>
          <div className="col-span-1 sm:col-span-5">
            <div className="flex pt-2 text-black text-justify font-dmsans text-sm sm:text-base">
              <span className="mt-1">
                NIRMAAN, the pre-incubator at IIT Madras, plays a key role in supporting students, 
                researchers, and alumni who are taking their first steps into entrepreneurship. 
                It helps turn early ideas and prototypes into real startup opportunities by offering mentorship,
                seed funding, prototyping support, and access to the wider IIT Madras startup ecosystem.
                In NIRMAAN, the focus is also to provide a closely working with all aspiring
                founders—helping them refine their ideas, validate their technology, and think through peer learning,
                business and market challenges—while supporting their journey from concept to a strong, scalable venture.
              </span>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-center text-4xl font-bold mt-16 mb-8 font-dmsans text-green-600">
            Our Supporters
          </div>

          <Marquee>
            <div className="flex space-x-6">
              <img src={Img23}  alt="supporter-logo" className="h-[100px] ms-10"/>
              <img src={Img1}   alt="supporter-logo" className="h-[100px]" />
              <img src={Img2}   alt="supporter-logo" className="h-[100px]" />
              <img src={Img4}   alt="supporter-logo" className="h-[50px] mt-6" />
              <img src={Img22}  alt="supporter-logo" className="h-[50px] mt-5" />
              <img src={Img19}  alt="supporter-logo" className="w-[400px]" />
              <img src={Img20}  alt="supporter-logo" className="h-[40px] mt-7 "/>
              <img src={Img21}  alt="supporter-logo" className="h-[40px] mt-7 "/>
              <img src={Img7}   alt="supporter-logo" className="h-[50px] w-[180px]  mt-7 "/>

            </div>
          </Marquee>
        </div>
      </div>

      <Carousel />

      <Footer />
    </div>
  );
};

export default Home;
